import {useAaMigrationGeneralTest} from './aaMigrationTests';

export const ActivateAaMigrationGeneralTest = () => {
  useAaMigrationGeneralTest();

  return null;
};
